import { getCompanyHubRoute } from '@confluence/ssr-app/entry-points/routes';

import { SpaceOverviewRouteComponent } from './SpaceOverviewRouteComponent';

export const CompanyHubRoute = getCompanyHubRoute(SpaceOverviewRouteComponent);
